import React, { useEffect, useRef, useState, useCallback } from "react";
import { Modal, ConfigProvider, Typography } from "antd";
import "react-form-builder2/dist/app.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { CloseCircleOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

export const AddSection = ({
  addSection,
  setAddSection,
  sectionName,
  setSectionName,
  handleAddSection,
}) => {
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Setting-FormBuilder-Add-Edit").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  return (
    <ConfigProvider
      theme={{
        components: {
          Modal: {
            contentBg: "#f1f1f1",
          },
        },
      }}
    >
      <Modal
        footer={null}
        centered
        open={addSection}
        style={{ borderRadius: 15 }}
        width={400}
        onCancel={() => setAddSection(false)}
        closeIcon={<CloseCircleOutlined />}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <label style={{ fontWeight: 300 }}>
            {/* Section Title */}
            {t("Section title ")}
          </label>
          <input
            value={sectionName}
            style={{
              padding: 10,
              borderRadius: 5,
              paddingBlock: 12,
              border: 0,
              backgroundColor: "",
              width: "90%",
              marginTop: "-8px",
            }}
            onChange={(e) => setSectionName(e.target.value)}
          />
        </div>
        <button
          className="addFormPOC ms-2 ascButton"
          onClick={handleAddSection}
          style={{ marginTop: 15, position: "relative", left: "25%" }}
        >
          {/* Add */}
          {t("Add  ")}
        </button>
      </Modal>
    </ConfigProvider>
  );
};

export const EditSection = ({
  editSection,
  setEditSection,
  sectionName,
  setSectionName,
  saveEditSection,
}) => {
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Setting-FormBuilder-Add-Edit").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  return (
    <ConfigProvider
      theme={{
        components: {
          Modal: {
            contentBg: "#f1f1f1",
          },
        },
      }}
    >
      <Modal
        footer={null}
        centered
        open={editSection}
        style={{ borderRadius: 15 }}
        width={400}
        onCancel={() => setEditSection(false)}
        closeIcon={<CloseCircleOutlined />}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <label style={{ fontWeight: 300 }}>
            {/* Section Title */}
            {t("Section title ")}
          </label>
          <input
            value={sectionName}
            style={{
              padding: 10,
              borderRadius: 5,
              paddingBlock: 12,
              border: 0,
              backgroundColor: "",
              width: "90%",
              marginTop: "-8px",
            }}
            onChange={(e) => setSectionName(e.target.value)}
          />
        </div>
        <button
          className="addFormPOC ms-2 ascButton"
          onClick={saveEditSection}
          style={{ marginTop: 15, position: "relative", left: "25%" }}
        >
          {/* Edit */}
          {t("Edit ")}
        </button>
      </Modal>
    </ConfigProvider>
  );
};

export const AddFormName = ({
  formNamePopupShow,
  setFormNamePopupShow,
  setFormName,
  formName,
}) => {
  const history = useHistory();
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Setting-FormBuilder-Add-Edit").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  return (
    <ConfigProvider
      theme={{
        components: {
          Modal: {
            contentBg: "#f1f1f1",
          },
        },
      }}
    >
      <Modal
        footer={null}
        centered
        open={formNamePopupShow}
        style={{ borderRadius: 15 }}
        width={400}
        onCancel={() => {
          setFormNamePopupShow(false);
          history.goBack();
        }}
        closeIcon={<CloseCircleOutlined />}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <Typography.Title
            level={5}
            style={{ marginBottom: 40, fontSize: 14 }}
          >
            {/* Give a name to the form to turn it unique */}
            {t("Give a name to the form to turn it unique")}
          </Typography.Title>
          <label style={{ fontWeight: 300 }}>
            {/* Form Name */}
            {t("Form Name")}
          </label>
          <input
            value={formName}
            style={{
              padding: 10,
              borderRadius: 5,
              paddingBlock: 12,
              border: 0,
              backgroundColor: "",
              width: "90%",
              marginTop: "-8px",
            }}
            onChange={(e) => setFormName(e.target.value)}
          />
        </div>
        <button
          className="addFormPOC ms-2 ascButton"
          onClick={() => setFormNamePopupShow(false)}
          style={{ marginTop: 25, position: "relative", left: "25%" }}
        >
          {/* Add */}
          {t("Add  ")}
        </button>
      </Modal>
    </ConfigProvider>
  );
};
